import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";

const PlaceAutocomplete = ({ onPlaceSelect, inputRef }) => {
    const [autocomplete, setAutocomplete] = useState(null);
    const places = useMapsLibrary("places");

    useEffect(() => {
        if (!places || !inputRef?.current) return;

        const options = {
            fields: ["geometry", "name", "formatted_address"],
        };
        const ac = new places.Autocomplete(inputRef.current, options);
        setAutocomplete(ac);
    }, [places, inputRef]);

    useEffect(() => {
        if (!autocomplete) return;

        const listener = autocomplete.addListener("place_changed", () => {
            onPlaceSelect(autocomplete.getPlace());
        });

        return () => listener.remove();
    }, [autocomplete, onPlaceSelect]);

    return null;
};

export default PlaceAutocomplete;
